import http from '@/http'
import { DraftPage } from '@/interfaces/admin'

export async function createDraftPage (dto: DraftPage): Promise<DraftPage> {
  const { data } = await http.post('/admin/draft-pages', dto)
  return data
}
